import type { FormInitialValuesType } from '../BusinessContactForm.types';

export const ANNUAL_CASH_FLOW_VALUES = [
    'brak danych',
    'do 200 tys.',
    'od 200 do 1 mln',
    'powyżej 1 mln',
] as const;

export const PAYMENT_GATEWAY_CARDS_CONFIG = [
    'Przelewy24',
    'Dotpay',
    'PayU',
    'Tpay',
    'Paynow',
    'Inne',
] as const;

export const FIRST_FORM_STEP_FIELDS: (keyof FormInitialValuesType)[] = [
    'name',
    'email',
    'phone_number',
    'nip',
];

export const SECOND_FORM_STEP_FIELDS: (keyof FormInitialValuesType)[] = [
    'website',
    'annual_cash_flow',
    'payment_gateway',
];

export const ERROR_MESSAGES_CONFIG = {
    global: 'Wystąpił błąd wysyłania formularza. Spróbuj ponownie później.',
};
